// Tokens.js
import React, { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { TokenContext } from "./tokenContext";
import "./Tokens.css";

function Tokens() {
  const navigate = useNavigate();
  const { setPurchaseIntent } = useContext(TokenContext);
  const [selectedTokens, setSelectedTokens] = useState(0); // State for selected token amount

  const handleTokenPurchase = () => {
    setPurchaseIntent(Number(selectedTokens) || 0);
    console.log("SelectedTokens: ", selectedTokens);
    navigate("/login"); // Navigate to login page
  };

  const navigateTo = (path) => {
    setPurchaseIntent(0);
    navigate(path);
  };

  return (
    <div className="TO-Tokens-container">
      <h1 className="TO-header-title">The iSpeakWell Project</h1>
      <h5 className="TO-tagline">
        Go from ESL to Fluent English with Practice, Confidence, and Distinction with the iSpeakWell Crew.
      </h5>
      <h1>Purchase Tokens</h1>
      <input 
        className="TO-TokenNum"
        type="number"
        value={selectedTokens}
        onChange={(e) => setSelectedTokens(e.target.value)}
        min="0"
        max="50"
      />
      <button className="TO-cta-button" onClick={handleTokenPurchase}>
        Buy Tokens
      </button>
      <h2 className="TO-token-header">What Are Tokens For?</h2>
      <p className="TO-token-description">
        Tokens unlock premium tools to boost your communication, confidence, and career readiness.
      </p>

      <div className="TO-token-grid">
        <div className="TO-token-card">AI Speaking Partner<br /><span>(1 Token - 25 Turns)</span></div>
        <div className="TO-token-card">AI Resume Revision, Keyword Analysis, Suggested Career Path, & Cover Letter Generation<br /><span>(1 Token)</span></div>
        <div className="TO-token-card">AI Interview Assessment<br /><span>(1 Token - 5 Questions & Response Analysis)</span></div>
        <div className="TO-token-card">AI-Prompted Speaking Plan<br /><span>(1 Token)</span></div>
        <div className="TO-token-card">AI Coached Professional Conversation Partner<br /><span>(1 Token - 25 Turns)</span></div>
        <div className="TO-token-card">Create a Private Training Room<br /><span>(10 Tokens)</span></div>
        <div className="TO-token-card">Join a Private Training Room<br /><span>(2 Tokens)</span></div>
        <div className="TO-token-card">
          <div>Why buy tokens?</div>
          <hr></hr>
          <span>For users who want to precisely control their spend!</span>
          <span>(Best Value)</span>
        </div>
      </div>
      <div className="TO-links-section">
          <button className="TO-link-button" onClick={() => navigateTo("/about")}>About</button>
          <button className="TO-link-button" onClick={() => navigateTo("/careers")}>Careers</button>
          <button className="TO-link-button" onClick={() => navigateTo("/tokens")}>Tokens</button>
          <button className="TO-link-button" onClick={() => navigateTo("/contactus")}>Contact Us</button>
          <button className="TO-link-button" onClick={() => navigateTo("/login")}>Login</button>
        </div>
    </div>
  );
}
export default Tokens;
